
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const About = lazy(() => import('../pages/about/page'));
const Services = lazy(() => import('../pages/services/page'));
const Projects = lazy(() => import('../pages/projects/page'));
const QuoteRequest = lazy(() => import('../pages/quote-request/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const MentionsLegales = lazy(() => import('../pages/legal/mentions-legales/page'));
const PolitiqueConfidentialite = lazy(() => import('../pages/legal/politique-confidentialite/page'));
const PolitiqueCookies = lazy(() => import('../pages/legal/politique-cookies/page'));
const ConditionsUtilisation = lazy(() => import('../pages/legal/conditions-utilisation/page'));
const ProtectionDonnees = lazy(() => import('../pages/legal/protection-donnees/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/services',
    element: <Services />,
  },
  {
    path: '/projects',
    element: <Projects />,
  },
  {
    path: '/quote-request',
    element: <QuoteRequest />,
  },
  {
    path: '/demander-un-devis',
    element: <QuoteRequest />,
  },
  {
    path: '/contact',
    element: <QuoteRequest />,
  },
  {
    path: '/mentions-legales',
    element: <MentionsLegales />,
  },
  {
    path: '/politique-de-confidentialite',
    element: <PolitiqueConfidentialite />,
  },
  {
    path: '/politique-de-cookies',
    element: <PolitiqueCookies />,
  },
  {
    path: '/conditions-utilisation',
    element: <ConditionsUtilisation />,
  },
  {
    path: '/protection-des-donnees',
    element: <ProtectionDonnees />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
